import { useSelector } from "react-redux";
import { Box, makeStyles, Typography, Grid } from "@material-ui/core";

import { Icon } from "../../../../../../components/base";
import { COLORS } from "../../../../../../theme/colors";
import placeholderImg from "../../../../../../assets/images/building/building-placeholder.png";

const useStyles = makeStyles(() => ({
  root: {
    cursor: "pointer",
    "&:hover": {
      backgroundColor: COLORS.darks[0][6],
    },
  },
  imageRoot: {
    height: "100%",
    width: "100%",
    objectFit: "cover",
  },
}));

export const BuildingCard = ({ building, onClick }) => {
  const classes = useStyles();
  const { user } = useSelector((state) => state.auth);

  return (
    <Box
      className={classes.root}
      p={2.25}
      mb={2}
      border="1px solid"
      borderRadius={8}
      borderColor={COLORS.darks[0][10]}
      bgcolor={COLORS.white}
      onClick={() => onClick(building)}
    >
      <Typography style={{ fontWeight: "bold" }}>{building.name}</Typography>
      <Box mb={1} color={COLORS.darks[0][50]}>
        {building.total_square} {user.unit_system} | {building.total_tenants} Tenants
      </Box>
      <Grid
        container
        justifyContent="center"
        alignContent="center"
        style={{ height: 160, background: building?.image ? null : COLORS.darks[0][6] }}
      >
        {building?.image ? (
          <Icon root={classes.imageRoot} src={building.image} />
        ) : (
          <Icon src={placeholderImg} />
        )}
      </Grid>
    </Box>
  );
};
